import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { LoginButton } from './styles';
import { ReactComponent as LockIcon } from '../../images/icons/lock-fill.svg';

const BlurWrapper = ({
	children,
	isBlurred,
	blurAmount = 3.5,
	overlayColor = 'rgba(217, 217, 217, 0.03)',
	showLoginButton,
	logIn
}) => {
	const { t } = useTranslation();

	return (
		<Box sx={{ position: 'relative' }}>
			<Box
				sx={{
					...(isBlurred && {
						filter: `blur(${blurAmount}px)`,
						pointerEvents: 'none'
					})
				}}>
				{children}
			</Box>

			{isBlurred && (
				<Box
					sx={{
						position: 'absolute',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: overlayColor,
						zIndex: 2,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						flexDirection: 'column'
					}}>
					{showLoginButton && (
						<LoginButton
							variant="contained"
							onClick={() => {
								logIn();
								setTimeout(() => {
									window.MyON?.open?.();
								}, 0);
							}}
							startIcon={<LockIcon />}>
							<Typography variant="h6" style={{ fontWeight: 600 }}>
								{t('components.summary.loginButton')}
							</Typography>
						</LoginButton>
					)}
				</Box>
			)}
		</Box>
	);
};

export default BlurWrapper;
